import './root';
import app from './app';
const moduleName = require('../../datashop.json').name;

window[`__${moduleName}__`] = {
  default: app
};

export default app;
